export function parseMoney(number?: number) {
  if (!number) {
    return '';
  }

  // Use Intl.NumberFormat for proper formatting with commas
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD', // Change 'USD' to your desired currency code
    minimumFractionDigits: 0, // No decimal places
  });

  return formatter.format(number).replace(/\.00$/, ''); // Remove ".00" at the end
}

export function parseMoneySafe(number?: number | string) {
  if (number === undefined || number === null || number === '') {
    return '';
  }

  // Use Intl.NumberFormat for proper formatting with commas
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD', // Change 'USD' to your desired currency code
    minimumFractionDigits: 0, // No decimal places
  });

  const parsedNumber = typeof number === 'number' ? number : Number.parseFloat(number);

  // Check if the parsed number is valid (not NaN)
  if (Number.isNaN(parsedNumber)) {
    return '';
  }

  return formatter.format(parsedNumber).replace(/\.00$/, ''); // Remove ".00" at the end
}
